import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import LegacyLayout from './LegacyLayout'
import WorkspaceLayout from 'components/Erp/WorkspaceLayout'
export default function Layout({ children }) {
  useInterfaceLanguage();
  const user = useSelector(state => state.user)
  const { pathname } = useLocation()
  const legacy = user.erp_role === 'employee' || (!user.erp_role && user.is_personal_kyrgyzkomur) || ['/employee-card', '/docflow', '/register_employee', '/admin_organizations'].some(path => pathname.startsWith(path))
  return legacy ? <LegacyLayout>{children}</LegacyLayout> : <WorkspaceLayout>{children}</WorkspaceLayout>
}
